import { IRequestOptions, RemoteDataStore } from '@move-frontend/utils';
import { action, makeObservable, observable } from 'mobx';
import { EmailSuggestionService } from '../../../../shared/api/gateway/services/EmailSuggestionService';
import { IEmailSuggestionQuery } from '../../../../shared/api/gateway/types/IEmailSuggestionQuery';
import { IEmailSuggestionResponse } from '../../../../shared/api/gateway/types/IEmailSuggestionResponse';

export class EmailSuggestionStore extends RemoteDataStore<
	IEmailSuggestionQuery,
	IEmailSuggestionResponse
> {
	private _suggestion: string | undefined = undefined;

	constructor(private readonly service: EmailSuggestionService) {
		super();

		makeObservable<EmailSuggestionStore, 'handleResponse' | '_suggestion'>(
			this,
			{
				handleResponse: action,
				clear: action,
				_suggestion: observable,
			},
		);
	}

	protected performRequest(
		params: IEmailSuggestionQuery,
		options: IRequestOptions,
	): Promise<IEmailSuggestionResponse> {
		return this.service.get(params, options);
	}

	protected handleResponse(response: IEmailSuggestionResponse): void {
		this._suggestion = response.suggestion;
	}

	get suggestion() {
		return this._suggestion;
	}

	clear() {
		this._suggestion = undefined;
	}
}
